exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-3fdef720] {\n  padding-bottom: 1rem;\n}\n.subscribe-button[data-v-3fdef720] {\n  padding-bottom: calc(1rem + 12px);\n}\n", ""]);

// exports
